module.exports = __webpack_public_path__ + "static/ca2x2-0ff866ac7f5cf35152e3b09218189edd.jpg";